import { createFileRoute } from '@tanstack/react-router'
import { AiSection } from '~/components/marketing/ai-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Planno AI — assistant and renderings for architects | Planno'
const PAGE_DESCRIPTION =
  'An assistant that has read the whole project: summaries, drafted documents, contract review against your own checklist, and SketchUp screenshots turned into renderings.'

export const Route = createFileRoute('/en/features/ai')({
  component: AiPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/features/ai',
      title: PAGE_TITLE,
    }),
})

function AiPage() {
  return (
    <MarketingShell locale="en">
      <AiSection headingLevel="h1" />
    </MarketingShell>
  )
}
